module.exports = __webpack_public_path__ + "img/step-six-icon.d31a7efa.jpg";